<div class="campanha-lead-filter">
    <div class="campanha-lead-filter-itens">
        <div class="campanha-lead-filter-item">
            <sgt-campanha-lead-visualizacao-modo
                [ngModel]="filter.visualizacaoModo"
                (ngModelChange)="onChangeModoVisualizacao($event)"
                name="campanhaLeadFilterVisualizacaoModo"
                id="campanhaLeadFilterVisualizacaoModo">
            </sgt-campanha-lead-visualizacao-modo>
        </div>
        <div class="campanha-lead-filter-item">
            <sgt-usuario-multiselect
                [(idsUsuarios)]="filter.idsUsuariosResponsaveis"
                (idsUsuariosChange)="onChangeUsuariosResponsaveis()"
                defaultTitle="Responsáveis">
            </sgt-usuario-multiselect>
        </div>
        <div class="campanha-lead-filter-item">

        </div>
        <div class="campanha-lead-filter-item">
            <sgt-classificacao-tipo-multiselect
                [(idsClassificacoes)]="filter.idsClassificacoes"
                (idsClassificacoesChange)="onChangeClassificacoes()"
                [(nullOption)]="filter.classificacaoNull"
                [showNullOption]="true"
                [tipoClassificacaoCadastroCliente]="true"
                defaultTitle="Classificações">
            </sgt-classificacao-tipo-multiselect> 
        </div>
        <div class="campanha-lead-filter-item">
            <sgt-temperatura-multiselect
                [(temperaturas)]="filter.temperaturas"
                (temperaturasChange)="onChangeTemperaturasLead()"
                defaultTitle="Temperaturas">
            </sgt-temperatura-multiselect>
        </div>            
    </div>
    <div class="campanha-lead-filter-options">
        <button type="button" class="btn btn-light" (click)="clear()" title="Limpar filtro e atualizar">
            <i class="fas fa-eraser" aria-hidden="true"></i> Limpar
        </button>
    </div>
</div>